const initialState = {
  restaurantRequests: [],
  restaurantOrders: [],
  unreadNotifications: [],
  allNotifications: [],
  restaurantOrdersRestData: [],
  readNotification: false,
  clearAllLoader: false,
  getNextLoader: false,
  restaurantCurrency: "",
  getNotificationsLoader: false,
  requestLoader: false,
  updateLoader: false,
  orderLoader: false,
  updateOrderLoader: false,
  unreadLoader: false,
  easyPaisaLoading: false,
  easyPaisaDetails: {},
  customerDetails: [],
  restaurantRequestsRest: [],
  subscriptionRequests: [],
};

const requestReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_ALL_REQUESTS": {
      return {
        ...state,
        restaurantRequests: payload,
      };
    }
    case "CLEAR_ALL_LOADER": {
      return {
        ...state,
        clearAllLoader: payload,
      };
    }
    case "SET_LOADER": {
      return {
        ...state,
        requestLoader: payload,
      };
    }
    case "UNREAD_LOADER": {
      return {
        ...state,
        unreadLoader: payload,
      };
    }
    case "UPDATE_ORDER_LOADER": {
      return {
        ...state,
        updateOrderLoader: payload,
      };
    }
    case "GET_NEXT_LOADER": {
      return {
        ...state,
        getNextLoader: payload,
      };
    }
    case "GET_NOTIFICATIONS_LOADER": {
      return {
        ...state,
        getNotificationsLoader: payload,
      };
    }

    case "GET_CUSTOMER_DETAIL": {
      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          [payload.customerID]: payload.data, // Add customer data for the specific customerID
        },
      };
    }
    case "NOTIFICATION_LOADER": {
      return {
        ...state,
        readNotification: payload,
      };
    }

    case "UPDATE_REQUESTS":
      return {
        ...state,
        restaurantRequests: {
          ...state.restaurantRequests,
          hits: state.restaurantRequests.hits.filter(
            (hit) => hit.id != action.payload
          ),
        },
      };

    case "UPDATE_LOADER": {
      return {
        ...state,
        updateLoader: payload,
      };
    }

    case "ORDERS": {
      return {
        ...state,
        restaurantOrders: payload,
      };
    }
    case "ORDERS_DETAILS": {
      return {
        ...state,
        restaurantOrdersRestData: payload,
      };
    }
    case "UPDATE_ORDER": {
      const updatedOrder = action.payload;
      return {
        ...state,
        restaurantOrders: state.restaurantOrders.map((order) =>
          order.id === updatedOrder.id ? { ...order, ...updatedOrder } : order
        ),
      };
    }
    case "ORDER_LOADER": {
      return {
        ...state,
        orderLoader: payload,
      };
    }
    case "UNREAD_NOTFICATIONS": {
      return {
        ...state,
        unreadNotifications: payload,
      };
    }
    case "ALL_NOTIFICATIONS": {
      return {
        ...state,
        allNotifications: payload,
      };
    }

    case "UPDATE_ORDER_STATUS": {
      const { id, status } = payload;
      let tempRestaurantOrders = JSON.parse(
        JSON.stringify(state.restaurantOrders)
      );
      const updatedOrders = tempRestaurantOrders.map((order) => {
        if (order.id === id) {
          return {
            ...order,
            status: status,
          };
        }
        return order;
      });
      return {
        ...state,
        restaurantOrders: [...updatedOrders],
      };
    }
    case "RESTAURANT_CURRENCY":
      return {
        ...state,
        restaurantCurrency: action.payload,
      };
    case "GET_SUBSCRIPTION_REQUESTS":
      return {
        ...state,
        subscriptionRequests: action.payload,
      };
    case "UPDATE_EASYPAISA":
      return {
        ...state,
        easyPaisaDetails: payload,
      };
    case "UPDATE_EASYPAISA_LOADER":
      return {
        ...state,
        easyPaisaLoading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default requestReducer;
